export default "__VITE_ASSET__C9VQbbdm__"